<template>   
    <div :style="size" id="map"></div>
</template>

<script>  
var mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');
 
mapboxgl.accessToken = 'pk.eyJ1IjoicmVnaXNqZWFybWJlcmEiLCJhIjoiY2p1d2FscG9yMDJuYjRkcG8yc2xoNjc3YiJ9.A7halTxXC0lVxg5geUkLWQ';
var map = new mapboxgl.Map({
    container: 'app',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [-74.5, 40], // starting position
    zoom: 9 // starting zoom
});
map.addControl(new mapboxgl.NavigationControl());

export default {
    props:[
        'mp_height',
        'mp_width',
        'mp_center',
        'mp_points',
        'mp_zoom'
    ],
    components: {  
    },
    data(){
        return{  
            visible:true,
            newMap:{},
            malawi:{lat:-13.2543,lng:34.3015},
            lilongwe:{lat:-13.9626,lng:33.7741},
             
        } 
    },
    mounted(){  
      //this.mapbox.addControl(new mapboxgl.NavigationControl());
    },
    created(){  
        // We need to set mapbox-gl library here in order to use it in template
        this.mapbox = map;
    },
    computed:{ 
        size(){
            let h = this.mp_height?this.mp_height:"300px"
            let w = this.mp_width?this.mp_width:"100%"
            return " height:"+h+"; width:"+w+"; "
        }
    },
    methods:{ 
        handleSearch(event) {
            console.log(event);
        } 

    },
    watch:{
       
    } 
}
</script> 

